__turbopack_context__.v({
  "l1": "cartModal-module-scss-module__zPNyuW__l1",
  "loader": "cartModal-module-scss-module__zPNyuW__loader",
  "wrapper": "cartModal-module-scss-module__zPNyuW__wrapper",
});
